module.exports = __webpack_public_path__ + "img/image-4.4d05d2b0.jpg";